import { LAYOUTS, USER_ROLES } from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";
import { BULK_PDF_EXPORT_ROUTE_NAMES } from "bulk-pdf-export/routes/routeNames";

const pdfExportAllowedRoles = [
  USER_ROLES.WEBMASTER,
  USER_ROLES.ORGANIZER,
  USER_ROLES.MANAGER,
  USER_ROLES.TEAMLEADER,
];

export const bulkPdfExportManageFragment: AppRouteRecordRaw[] = [
  {
    name: "manageBulkPdfIndex",
    path: "bulk-pdf",
    component: () => import("views/EmptyView.vue"),
    redirect: { name: BULK_PDF_EXPORT_ROUTE_NAMES.MANAGE },
    meta: {
      title: "PDF-export",
      isMenuItem: true,
      hideSidebarSubmenu: true,
      menuSection: "manage",
      roleRequired: pdfExportAllowedRoles,
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
    children: [
      {
        name: BULK_PDF_EXPORT_ROUTE_NAMES.MANAGE,
        path: "",
        component: () =>
          import("bulk-pdf-export/pages/BulkPdfExportsOverviewPage.vue"),
        meta: {
          title: "PDF-export",
          roleRequired: pdfExportAllowedRoles,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        name: "bulkPdfCreatePortfolio",
        path: "create/portfolio",
        component: () =>
          import("bulk-pdf-export/pages/BulkPdfExportPortfolioCreatePage.vue"),
        meta: {
          title: "Portfolio PDF-export aanmaken",
          roleRequired: pdfExportAllowedRoles,
          hideTitle: true,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        name: "bulkPdfCreateStudentMeeting",
        path: "create/leerlingbespreking",
        component: () =>
          import(
            "bulk-pdf-export/pages/BulkPdfExportStudentMeetingCreatePage.vue"
          ),
        meta: {
          title: "Leerlingbespreking PDF-export aanmaken",
          roleRequired: pdfExportAllowedRoles,
          hideTitle: true,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
    ],
  },
];
